class PageBreadcrumbsDropdown
{
    dropdownLabel = '';
    dropdownOpen = false;

    init(){
        const dropdownList = this.$el.querySelector('.Dropdown__Container ul');
        const dropdownItems = dropdownList.querySelectorAll('li');
        const itemAnchors = dropdownList.querySelectorAll('a');

        this.dropdownLabel = dropdownItems[0].innerText;

        itemAnchors.forEach((item, index) => {
            console.log('item', item);
            console.log('href', item.getAttribute('href'));
            console.log('window.location.href', window.location.href);
            if(item.getAttribute('href') === window.location.href){
                this.dropdownLabel = itemAnchors[index].innerText;
            }
        });


        const container = this.$root.closest('.Pegasus__Container');

        if(container){
            container.style.zIndex = 19;
        }

        
    }
}


document.addEventListener('alpine:init', () => {
    Alpine.data('pageBreadcrumbsDropdown', () => new PageBreadcrumbsDropdown());
});

class PageBreadcrumbs
{

    init(){
        this.hideOnMobile();
        this.reducePaddingOnMobile();
    }

    hideOnMobile() {
        const hideOnMobile = this.$el.classList.contains('hide-on-mobile');

        if(!hideOnMobile){
            return;
        }

        const parentContainer = this.$el.closest('.Pegasus__Container');

        if(window.innerWidth < 768){
            parentContainer.style.display = 'none';
        }
    }

    reducePaddingOnMobile() {
        const parentContainer = this.$el.closest('.Pegasus__Container');

        parentContainer.classList.add('reduce-padding-on-mobile');
    }
}


document.addEventListener('alpine:init', () => {
    Alpine.data('pageBreadcrumbs', () => new PageBreadcrumbs());
});